import { render, staticRenderFns } from "./DetailTracking.vue?vue&type=template&id=54384a7e"
import script from "./DetailTracking.vue?vue&type=script&lang=js"
export * from "./DetailTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports